export default __webpack_public_path__ + "static/media/smart_school_icon.f7ba7222.png";